import Vue from 'vue';
import Vuex from 'vuex';
import 'es6-promise/auto';
import motors from './modules/motors';
import circuits from './modules/circuits';
import preference from './modules/preference';
import pumps from './modules/pumps';
import tanks from './modules/tanks';
import tankerFloats from './modules/tankerFloats';
import build from './modules/build';
import valves from './modules/valves';
import additionalValves from './modules/additional-valves';
import frameOptions from './modules/frame-options';
import electricalBoxes from './modules/electricalBoxes';
import oilCoolers from "./modules/oilCoolers";
import workplaceOptions from "./modules/workplace-options";
import powerpackOptions from "./modules/powerpack-options";
import openFrameOptions from "./modules/open-frame-options";
import tooltips from "./modules/tooltips";
import powerpackPreferences from "./modules/powerpack-preferences";
import cilinders from "./modules/cilinders";
import cart from "./modules/cart";
import hoses from "./modules/hose/hoses";
import couplings from "./modules/hose/couplings";
import press from "./modules/hose/press";
import lids from "./modules/lids";
import elasticCouplings from './modules/elastic-couplings';
import lanternPieces from "./modules/lantern-pieces";
import motorConfigMotors from './modules/motor/motors';
import motorConfigTypes from './modules/motor/types';
import closedFrameOptions from "@/store/modules/closed-frame-options";
import waterAbsorbentTankAerations from "@/store/modules/water-absorbent-tank-aerations";
import auth from "@/store/modules/auth";

// eslint-disable-next-line no-console

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    state: {
        device: null,
    },
    modules: {
        pumps,
        valves,
        additionalValves,
        motors,
        circuits,
        tanks,
        tankerFloats,
        waterAbsorbentTankAerations,
        preference,
        build,
        electricalBoxes,
        frameOptions,
        oilCoolers,
        workplaceOptions,
        powerpackOptions,
        openFrameOptions,
        closedFrameOptions,
        tooltips,
        powerpackPreferences,
        cilinders,
        cart,
        hoses,
        couplings,
        press,
        lids,
        elasticCouplings,
        lanternPieces,
        motorConfigMotors,
        motorConfigTypes,
        auth,
    },
    actions: {
        async initAll({commit, dispatch}) {
            return await Promise.all([
                dispatch('auth/getLoginCredentials'),
                dispatch('circuits/index'),
                dispatch('valves/index'),
                dispatch('pumps/index'),
                dispatch('tanks/index'),
                dispatch('tankerFloats/index'),
                dispatch('waterAbsorbentTankAerations/index'),
                dispatch('additionalValves/index'),
                dispatch('electricalBoxes/index'),
                dispatch('frameOptions/index'),
                dispatch('oilCoolers/index'),
                dispatch('workplaceOptions/index'),
                dispatch('powerpackOptions/index'),
                dispatch('tooltips/index'),
                dispatch('hoses/index'),
                dispatch('couplings/index'),
                dispatch('press/index'),
                dispatch('lids/index'),
                dispatch('elasticCouplings/index'),
                dispatch('lanternPieces/index'),
                dispatch('motorConfigMotors/index'),
                dispatch('motorConfigTypes/index'),
                dispatch('openFrameOptions/index'),
                dispatch('closedFrameOptions/index'),
                dispatch('motors/index'), // show depends on motor so make this request as last!
            ])
        },
        setDevice({commit}, device) {
            commit('setDevice', device);
        }
    },
    mutations: {
        setDevice(state, data) {
            state.device = data;
        },
    },
    getters: {
        getDevice(state) {
            return state.device;
            // return window.outerWidth < 1100 ? 'mobile' : 'desktop';
        },
    },
    strict: debug,
});
